import {Compass} from 'lucide-react';
import {Typography} from "../ui/Typography";


export const NotFound404 = (any) => {
    const pageNotFoundText = "Het lijkt erop dat de pagina die je zoekt is verplaatst, verwijderd of niet bestaat. " +
        "Laten we je weer op het juiste spoor zetten.";

    return (
        <div className="flex flex-col">
            <main className="flex-grow">
                <section className="py-24 sm:py-32">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <div className="relative flex flex-col items-center">
                            <p
                               aria-hidden="true"
                                className="text-[10rem] sm:text-[12rem] md:text-[16rem] font-extrabold text-surface-900 leading-none"
                            >
                                404
                            </p>

                            <div className="flex flex-col items-center mt-20 sm:-mt-24 md:-mt-32">
                                
                                <Compass size={64} className="text-brand-500" />
                                
                                <Typography
                                    as="h1"
                                    variant="h1"
                                    className="ttracking-tight text-brand-500"
                                >
                                    Pagina Niet Gevonden
                                </Typography>
                                
                                <Typography as="p" variant="p" className="mt-4 max-w-xl text-lg text-surface-700">
                                    {pageNotFoundText}
                                </Typography>
                                
                                
                                <a href="/"
                                   className="mt-8 inline-block bg-brand-500 text-surface-100 font-semibold
                                    px-8 py-3 rounded-lg hover:bg-opacity-90 transition-all shadow-lg 
                                    shadow-brand-500/20 focus:outline-none focus:ring-2 focus:ring-brand-500 
                                    focus:ring-offset-2 focus:ring-offset-[var(--bg-primary)]">
                                    Terug naar de Homepage
                                </a>
                            </div>
                        </div>

                    </div>
                </section>
            </main>
        </div>
    );
};





